<template>
  <div class="row">
    <div class="col-md-12">
      <div v-if="evalformdata.chaptersOnOnePage === 0" class="flex-container evalfooter">
        <div class="flex-item">
          <button v-on:click.prevent="prevchapter()" v-if="showprevbtn" class="btn btn-primary">
            {{ translation(4849) }}
          </button>
          <button v-on:click.prevent="validatechapter()" v-if="shownextbtn" class="btn btn-primary">
            {{ translation(4848) }}
          </button>
          <button
            v-on:click.prevent="validatechapter()"
            :disabled="evaldone"
            v-if="showfinishbtn"
            class="btn btn-primary"
          >
            {{ translation(29) }}
          </button>
          <span v-if="showdisabledbtn"
            >&nbsp;&nbsp;<strong>{{ translation(14326) }}</strong></span
          >
        </div>
        <div class="flex-item voortgangpadding1" v-if="showchapters">
          <div class="evalvoortgang">
            <div
              class="evalvoortgang2"
              :class="[
                { 'bckcol-primary': valid || !validationtriggered },
                { 'bckcol-warning': !valid && validationtriggered },
              ]"
              v-bind:style="{ width: voortgangwidth }"
            ></div>
          </div>
        </div>
        <div class="flex-item voortgangpadding2" v-if="showchapters">
          <div>
            <span class="textevalfooter">{{ translation(758) }} </span>
            <span class="textevalfooter"> {{ currentchapter + 1 }} {{ translation(2030) }} {{ chapters.length }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="evalformdata.chaptersOnOnePage === 1 && evalformdata.datefilled === null"
        class="flex-container evalfooter"
      >
        <div class="flex-item">
          <button v-on:click.prevent="validatechapter()" :disabled="evaldone" class="btn btn-primary">
            {{ translation(29) }}
          </button>
        </div>
      </div>
      <div
        v-if="evalformdata.chaptersOnOnePage === 1 && evalformdata.datefilled !== null"
        class="flex-container evalfooter"
      >
        <div class="flex-item">
          <span v-if="showdisabledbtn"
            >&nbsp;&nbsp;<strong>{{ translation(14326) }}</strong></span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'evalfooter',
  props: ['visible'],
  data: function () {
    return {
      valid: false,
    }
  },
  computed: {
    ...mapGetters('evalstore', ['validationtriggered', 'currentchapter', 'chapters', 'evalformdata', 'evaldone']),
    shownextbtn: function () {
      return this.chapters.length > 1 && this.currentchapter < this.chapters.length - 1
    },
    showprevbtn: function () {
      return this.currentchapter !== 0
    },
    showfinishbtn: function () {
      return (
        (this.chapters.length === 1 || this.currentchapter === this.chapters.length - 1) &&
        this.evalformdata.datefilled === null
      )
    },
    showdisabledbtn: function () {
      return this.evalformdata.datefilled !== null
    },
    showchapters: function () {
      return this.chapters.length > 1
    },
    voortgangwidth: function () {
      return (100 / this.chapters.length) * (this.currentchapter + 1) + '%'
    },
  },
  methods: {
    ...mapMutations('evalstore', ['prevchapter', 'triggervalidation', 'nextchapter']),
    validatechapter: function () {
      this.$emit('validate')
    },
  },
  mounted: function () {},
}
</script>
